module.exports = __webpack_public_path__ + "static/media/export_bg.772d7faf.png";